export class PasswordModel {
  public current = ''
  public new = ''
  public verify = ''
}
